import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowsClockwise, XCircle } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (sessionId) pollStatus(0);
    else setStatus('error');
  }, [sessionId]);

  const pollStatus = async (attempt) => {
    if (attempt >= 5) { setStatus('timeout'); return; }
    try {
      const { data } = await axios.get(`${API_URL}/api/payments/status/${sessionId}`, { withCredentials: true });
      if (data.payment_status === 'paid') { setStatus('success'); return; }
      if (data.status === 'expired') { setStatus('expired'); return; }
      setTimeout(() => pollStatus(attempt + 1), 2000);
    } catch (err) {
      setTimeout(() => pollStatus(attempt + 1), 2000);
    }
  };

  return (
    <div className="app-container flex items-center justify-center min-h-screen px-6" data-testid="payment-success-page">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center">
        {status === 'checking' && (
          <>
            <ArrowsClockwise size={48} className="text-[#9D4CDD] mx-auto mb-4 animate-spin" />
            <h2 className="text-white text-lg font-bold mb-2">Confirming Payment...</h2>
            <p className="text-[#71717A] text-sm">Please wait while we verify your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={64} weight="fill" className="text-[#39FF14] mx-auto mb-4" />
            <h2 className="text-white text-lg font-bold mb-2">Payment Successful!</h2>
            <p className="text-[#71717A] text-sm mb-6">Your account has been updated.</p>
            <button onClick={() => navigate('/')} className="btn-primary px-8">Go Home</button>
          </>
        )}
        {(status === 'expired' || status === 'timeout' || status === 'error') && (
          <>
            <XCircle size={64} weight="fill" className="text-[#EF4444] mx-auto mb-4" />
            <h2 className="text-white text-lg font-bold mb-2">Payment Issue</h2>
            <p className="text-[#71717A] text-sm mb-6">
              {status === 'expired' ? 'Payment session expired.' : 'Could not verify payment.'}
            </p>
            <button onClick={() => navigate('/payments')} className="btn-primary px-8">Try Again</button>
          </>
        )}
      </motion.div>
    </div>
  );
}
